import React from 'react';

import { Flex, theme } from '@betterment/style-closet-react';
import ContentLoader from 'react-content-loader';

import SummaryCard from '../Shared/components/SummaryCard';

const ShimmerRectangle: React.FC<React.PropsWithChildren<{ width: number }>> = ({ width }) => (
  <ContentLoader
    style={{ display: 'block' }}
    ariaLabel="Loading performance highlights"
    gradientRatio={2}
    height={73}
    width={width}
    speed={0.99}
    interval={0.2}
    primaryColor={theme.colors.bmtGrey10}
    secondaryColor={theme.colors.bmtGrey20}
  >
    <rect x="0" y="29" rx="0" ry="0" width={width} height="14" />
  </ContentLoader>
);

export function HighlightCardLoader() {
  return (
    <SummaryCard mb="6">
      <Flex borderBottom="1px solid" borderColor="bmtGrey20">
        <Flex display="block" flexBasis="146px">
          <ShimmerRectangle width={146} />
        </Flex>
      </Flex>
      <Flex>
        <Flex display="block" flexBasis="195px">
          <ShimmerRectangle width={195} />
        </Flex>
      </Flex>
    </SummaryCard>
  );
}

const HighlightsLoader: React.FC<React.PropsWithChildren<{ mobileView?: boolean }>> = ({ mobileView = false }) => (
  <>
    <HighlightCardLoader />
    {!mobileView && <HighlightCardLoader />}
  </>
);

export default HighlightsLoader;
